import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { IKeyValueInterface } from './../../shared/config';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SpecialPeriodModel } from '../models/specialperiod.model';
import { SpecialPeriodService } from '../models/specialperiod.service';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL } from '../../shared/config';
import { Location } from '@angular/common';

@Component({
  selector: 'wego-specialperiod-update',
  template: require('../views/specialperiod-update.component.html'),
  providers: [SpecialPeriodService],
})

export class SpecialPeriodUpdateComponent implements OnInit, OnDestroy {
  public timeFormat: string = WeGoConfig.FLATPICKR_TIME_FORMAT;
  submitted = false;
  private sub: any;
  model: SpecialPeriodModel;
  apiResponse: IAPIResponse;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  message: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  specialPeriodHashId: string;
  urlSPecialPeriodList: string;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;

  flatPickrConfigTimeFrom: FlatPickrModel;
  flatPickrConfigTimeTo: FlatPickrModel;


  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private specialperiodService: SpecialPeriodService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location) {
  }
  ngOnInit() {

    this.module = this.translate.instant('LblSpecialPeriod');
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSPecialPeriodList = this.authService.GetURL(ApplicationRouteURL.URL_SPECIAL_PERIOD_LIST)
    this.model = new SpecialPeriodModel();
    this.flatPickrConfigTimeFrom = this.SetDefaultFlatTimePickrConfig();
    this.flatPickrConfigTimeTo = this.SetDefaultFlatTimePickrConfig();
    this.GetSpecialPeriodDetails();
  }

  private SetDefaultFlatTimePickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.noCalendar = true;
    flatPickrConfig.dateFormat = this.timeFormat;
    return flatPickrConfig;
  }

  public GetSpecialPeriodDetails() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.specialPeriodHashId = params['specialPeriodHashId'] || '';
        if (this.specialPeriodHashId != '') {
          this.isEditMode = true;
          this.specialperiodService.GetSpecialPerionByHashId(this.specialPeriodHashId)
            .subscribe(
            res => this.model = res.data,
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
            }
            );
        }
      });
    this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
  }

  onSubmit(forms: any) {
    this.AddNewSpecialPeriod();
  }

  public AddNewSpecialPeriod() {
    this.specialperiodService.UpdateSpecialPeriod(this.model)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblRecordUpdatedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/specialperiod/components/specialperiod-update.component.ts